export const stripCdmPrefix = (col) => {
    const dotStripped = col.replace(/^CDM_\w+\./, "");
    if (dotStripped !== col) return dotStripped;
    const lastSep = Math.max(col.lastIndexOf("_"), col.lastIndexOf("."));
    return lastSep >= 0 && col.startsWith("CDM_") ? col.substring(lastSep + 1) : col;
};

export const cdmFieldTail = (cdmId) => (cdmId && cdmId.includes(".") ? cdmId.split(".").pop() : cdmId) || "";

export const normalizeCdmTail = (s) => cdmFieldTail(s || "").replace(/\s/g, "").toLowerCase();

export const normalizeCdmMatchKey = (s) => {
    let t = normalizeCdmTail(s);
    if (t.startsWith("clb_")) t = t.slice(4);
    return t;
};

export const resolveAiTargetToGridFieldId = (targetField, mschFields) => {
    if (!targetField || !mschFields?.length) return targetField;
    const exact = mschFields.find((f) => f.id === targetField);
    if (exact) return exact.id;

    const aiKey = normalizeCdmMatchKey(targetField);
    if (aiKey) {
        const byTail = mschFields.find((f) => normalizeCdmMatchKey(f.id) === aiKey);
        if (byTail) return byTail.id;
        const byDbName = mschFields.find((f) => f.name && normalizeCdmMatchKey(f.name) === aiKey);
        if (byDbName) return byDbName.id;
    }

    const lower = targetField.toLowerCase();
    const byCase = mschFields.find((f) => f.id.toLowerCase() === lower);
    if (byCase) return byCase.id;

    return targetField;
};

export const looksLikeNumber = (value) => value !== "" && !isNaN(Number(value));
export const looksLikeDate = (value) => !isNaN(Date.parse(value));

export const isCellMismatchResolved = (value, targetType, sourceType) => {
    if (value === "" || value == null) return true;

    if (targetType === "number") return looksLikeNumber(value);
    if (targetType === "date") return looksLikeDate(value);

    if (targetType === "text") {
        if (sourceType === "number") return !looksLikeNumber(value);
        if (sourceType === "date") return !looksLikeDate(value);
    }
    return true;
};

export const buildDgItems = (csvRows, columns) =>
    csvRows.map((row, index) => ({
        id: row[columns[0]] || `${index}`,
        uniqueId: `${index}`,
        CLB_ID: row.CLB_ID ?? row["CDM_CustomCSV.CLB_ID"],
        card: columns.map((col) => [{ value: row[col] ?? "" }]),
    }));
